import { enableMapSet } from 'immer';

// 在创建 store 之前启用 MapSet 支持
enableMapSet();
